<a mat-icon-button
   flex
   [matMenuTriggerFor]="clientActions">
  <mat-icon>more_vert</mat-icon>
</a>

<mat-menu #clientActions="matMenu">
  @if (config.showCreateNewCredit && clientId) {
  <button mat-menu-item
          routerLink="/credits/new/fill-credit"
          [queryParams]="{ client: clientId }">
    <mat-icon>add</mat-icon>
    <span [translate]="'credits.newCredit'">New Credit</span>
  </button>
  }

  @if (config.showCreateOFfer && clientId) {
  <button mat-menu-item
          [disabled]="['CLIENT_PRICING_OFFER_ADD'] | isUnauthorized | async"
          *ngxPermissionsOnly="'CLIENT_PRICING_OFFER_ADD'"
          (click)="onOpenCreateOfferClick()">
    <mat-icon svgIcon="PRICING_OFFER"></mat-icon>
    <span [translate]="'clientPricingOffers.createOffer'">New pricing offer</span>
  </button>
  }

  @if (config.showCreateCreditLimitOffer && clientId) {
  <button mat-menu-item
          [disabled]="['CREDIT_LIMIT_OFFER_ADD'] | isUnauthorized | async"
          *ngxPermissionsOnly="'CREDIT_LIMIT_OFFER_ADD'"
          (click)="onOpenCreateCreditLimitOfferClick()">
    <mat-icon>credit_card</mat-icon>
    <span [translate]="'creditLimitOffers.createLimitOffer'">New credit limit</span>
  </button>
  }

  <a mat-menu-item
     [matMenuTriggerFor]="reports">
    <mat-icon>description</mat-icon>
    <span [translate]="'global.report'">Queries</span>
  </a>

  <mat-menu #reports="matMenu">
    @if (!isInputClient && config.showCommunication && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/communication">
      <mat-icon>message</mat-icon>
      <span [translate]="'global.communication'">Client Communication</span>
    </a>
    }

    @if (config.showClaims && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/claims">
      <mat-icon>assignment_late</mat-icon>
      <span [translate]="'clients.claims'">Client Claims</span>
    </a>
    }

    @if (!isInputClient && config.showCreditsHistory && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/credits">
      <mat-icon>perm_contact_calendar</mat-icon>
      <span [translate]="'clients.clientCreditsHistory'">Credits History</span>
    </a>
    }

    @if (!isInputClient && config.showCCR && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/ccr">
      <mat-icon>folder</mat-icon>
      <span [translate]="'ccr.viewCcr'">View CCR</span>
    </a>
    }

    @if (!isInputClient && config.showNssiReports && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/nssi">
      <mat-icon>folder</mat-icon>
      <span [translate]="'nssi.reports'">View NSSI Reports</span>
    </a>
    }

    @if (!isInputClient && config.showMiReports && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/mi">
      <mat-icon>folder</mat-icon>
      <span [translate]="'mi.reports'">View MI Reports</span>
    </a>
    }

    @if (!isInputClient && config.showRelatedPeople && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/related-people">
      <mat-icon>people</mat-icon>
      <span [translate]="'clients.relatedPeople'">View related people</span>
    </a>
    }

    @if (config.showClientHistory && clientId) {
    <a mat-menu-item
       routerLink="/clients/{{ clientId }}/history">
      <mat-icon>history</mat-icon>
      <span [translate]="'global.viewHistory'">View client history</span>
    </a>
    }</mat-menu>

  <!-- TODO: Review brand code logic -->

  <button mat-menu-item
          (click)="onTempPassSmsClick()"
          [disabled]="
      isNewItem ||
      !data?.mobileConfirmed ||
      data?.brand.code === 'MF' ||
      (['SMS_SEND'] | isUnauthorized | async)
    ">
    <mat-icon>vpn_key</mat-icon>
    <span [translate]="'clients.temporaryPasswordSms'">Temp Pass SMS</span>
  </button>

  <button mat-menu-item
          (click)="onTempPassEmailClick()"
          [disabled]="
      isNewItem ||
      !data?.emailConfirmed ||
      data?.brand.code === 'MF' ||
      (['EMAIL_SEND'] | isUnauthorized | async)
    ">
    <mat-icon>vpn_key</mat-icon>
    <span [translate]="'clients.temporaryPasswordMail'">Temp Pass Mail</span>
  </button>
</mat-menu>
